// Zweck: Einzelgerät mit Zustand und erlaubten Aktionen anzeigen. Stand: 21.10.2026.
import type { SimDevice, SimEvent } from '../interfaces/deviceSimulation';
import { WarehouseIcon } from './WarehousePresentation';
import { availableDevice } from '../services/deviceSimulation';
interface Props {
  d: SimDevice;
  articleName: string;
  locationLabel: string;
  projectLabel?: string;
  blocked: boolean;
  canManage: boolean;
  conditions: Record<string, string>;
  titles: Record<string, string>;
  events: SimEvent[] | null;
  onBlocked: () => void;
  onAction: (kind: string, device: SimDevice) => Promise<void>;
  onHistory: () => void;
  onCloseHistory: () => void;
}
export default function WarehouseDeviceCard({
  d,
  articleName,
  locationLabel,
  projectLabel,
  blocked,
  canManage,
  conditions,
  titles,
  events,
  onBlocked,
  onAction,
  onHistory,
  onCloseHistory,
}: Props) {
  return (
    <article
      className="wh-line wh-device-card"
      key={d.id}
      id={'device-' + d.id}
      tabIndex={-1}
    >
      <h3>{articleName}</h3>
      <strong>
        {d.serial ? 'Seriennummer' : 'Vorläufige Kennzeichnung'}{' '}
        {d.serial ?? d.label}
      </strong>
      <p>
        {blocked ? 'Schaden / Prüfung gemeldet' : conditions[d.condition]} ·{' '}
        {d.state === 'issued'
          ? 'Ausgegeben an ' + (projectLabel ?? d.projectId)
          : d.state === 'withdrawn'
            ? 'Zurückgebucht'
            : locationLabel}
      </p>
      <strong className="wh-device-status">
        {blocked
          ? 'Schadensmeldung offen · nicht ausgeben'
          : availableDevice(d)
            ? 'Verwendbar'
            : d.state === 'in_stock'
              ? 'Gesperrt · nicht ausgeben'
              : ''}
      </strong>
      <div className="wh-device-actions">
        {blocked && (
          <button onClick={() => onBlocked()}>
            <WarehouseIcon kind="warning" />
            Schadensmeldung prüfen
          </button>
        )}
        {!blocked &&
          d.condition !== 'ok' &&
          (canManage ? (
            d.serial ? (
              <button onClick={() => void onAction('release', d)}>
                <WarehouseIcon kind="release" />
                Gerät freigeben
              </button>
            ) : (
              <div>
                <p className="wh-notice">
                  Vor der Freigabe die Seriennummer berichtigen.
                </p>
                <button onClick={() => void onAction('serial', d)}>
                  <WarehouseIcon kind="edit" />
                  Seriennummer berichtigen
                </button>
              </div>
            )
          ) : (
            <p className="wh-notice">
              Gerät gesperrt. Bitte die Lagerkraft um Prüfung und Freigabe
              bitten.
            </p>
          ))}
        {!blocked && d.condition === 'ok' && (
          <button onClick={() => void onAction('block', d)}>
            <WarehouseIcon kind="warning" />
            Beschädigung / Prüfung melden
          </button>
        )}
        <details>
          <summary>Details und Aktionen</summary>
          <p className="wh-device-note">
            <strong>Gerätenotiz:</strong>{' '}
            {d.note || 'Noch keine Notiz hinterlegt.'}
          </p>
          <div className="wh-device-actions">
            <button onClick={() => void onHistory()}>
              <WarehouseIcon kind="history" />
              Gerätehistorie ansehen
            </button>
            {events !== null && (
              <aside className="wh-notice" aria-label="Gerätehistorie">
                <h4>Historie {d.serial ?? d.label}</h4>
                {!events?.length && (
                  <p>Noch keine Gerätebewegungen vorhanden.</p>
                )}
                {events?.map((ev) => (
                  <p key={ev.id}>
                    {new Date(ev.at).toLocaleString('de-DE')} ·{' '}
                    {titles[ev.kind] ?? ev.kind} · {ev.actor} {ev.reason}
                  </p>
                ))}
                <button onClick={() => onCloseHistory()}>
                  Historie schließen
                </button>
              </aside>
            )}
            <button onClick={() => void onAction('note', d)}>
              <WarehouseIcon kind="edit" />
              Notiz ändern
            </button>
            {canManage && d.serial && (
              <>
                <button onClick={() => void onAction('serial', d)}>
                  <WarehouseIcon kind="edit" />
                  Seriennummer berichtigen
                </button>
              </>
            )}
            {d.condition !== 'ok' && (
              <button onClick={() => void onAction('block', d)}>
                <WarehouseIcon kind="warning" />
                Beschädigung / Prüfung melden
              </button>
            )}
          </div>
        </details>
      </div>
    </article>
  );
}
